import Css from "./Css.js";
import { useRef, useEffect } from "react";
import drawLineUtil from '../../Utils/DrawLine.js';

function PaintBoard(props) {
  const {points,selStartTime,selEndTime,middleWidth,lvsPatternEditorId,editorMode,editPointPositionArr,batchSelPointPositionArr} = props.data;
  const {canvasMouseUp,canvasMouseDown,canvasMouseMove,canvasDBClick,
    clickCanvas,canvasDivMouseLeave,canvasMouseLeave} = props.method;
  const boardCanvas = useRef(null);
  const totalTime = selEndTime - selStartTime;
  const smoothLevel = getSmoothLevel(totalTime);
  let color = "#FF2D89";
  let lineWidth = 1.4;
  const editorCanvasId = lvsPatternEditorId + "_canvas";
  if(editorMode.edMode === 2){
    color = "#CCC";
    lineWidth = 1;
  }else if(editorMode.edMode === 3){
    color = "#CCC";
  }
  const padding = 12;
  const canvasWidth = middleWidth - padding;
  useEffect(() => {
    const { clientWidth: width, clientHeight: height } = boardCanvas.current;
    boardCanvas.current.width = width;
    boardCanvas.current.height = height;
    const pts = points.reduce((p, { v, t }) => {
      let x = parseInt(((t - selStartTime) / (selEndTime - selStartTime)) * width);
      let y = parseInt(((((20 - v) / 20) * height) / 4) * 2.77 + height / 7.2);
      p.push(x);
      p.push(y);
      return p;
    }, []);
    const ctx = boardCanvas.current.getContext("2d");
    ctx.clearRect(0, 0, width, height);
    //画曲线
    drawLineUtil.drawCurve(ctx,pts,smoothLevel,color,lineWidth,true,false,16,editPointPositionArr,batchSelPointPositionArr);

  }, [points,selStartTime,selEndTime,smoothLevel,color,editPointPositionArr,batchSelPointPositionArr,editorMode,lineWidth]);

  return (
    <>
      <div 
        style={Css.PaintBoard(canvasWidth, parseInt(padding/2))}
        onMouseLeave={ ()=>{ canvasDivMouseLeave() } }
      >
        <canvas
          id={editorCanvasId}
          onMouseUp={ (e)=>{ canvasMouseUp(e) } }
          onMouseDown={ (e)=>{ canvasMouseDown(e) } }
          onMouseMove={ (e)=>{ canvasMouseMove(e) } }
          onDoubleClick={ (e)=>{ canvasDBClick(e) } }
          onMouseLeave={ (e)=>{ canvasMouseLeave(e) } }
          onClick={ (e)=>{ clickCanvas(e) } }
          style={ Css.Canvas(editorMode) }
          ref={boardCanvas}
        ></canvas>
      </div>
    </>
  );
}

//获取线条平滑等级
function getSmoothLevel(totalTime){
  let smoothLevel = 0;
  if(totalTime >= 60*1000){
    smoothLevel = 0.1;
  }else if(totalTime >= 30*1000){
    smoothLevel = 0.15;
  }else if(totalTime >= 20*1000){
    smoothLevel = 0.2;
  }else if(totalTime >= 10*1000){
    smoothLevel = 0.3;
  }else if(totalTime >= 5*1000){
    smoothLevel = 0.4;
  }else if(totalTime >= 2*1000){
    smoothLevel = 0;
  }else if(totalTime >= 1000){
    smoothLevel = 0;
  }else{
    smoothLevel = 0;
  }
  return smoothLevel;
}

export default PaintBoard;
